export default __webpack_public_path__ + "static/media/statistics.8e2370aa.svg";